/**
 * @generated SignedSource<<0eba75ca08652a6202a4f792600421c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BuildTypeLineBranchesCountQuery$variables = {
  btLocator: string;
  locator?: string | null | undefined;
};
export type BuildTypeLineBranchesCountQuery$data = {
  readonly branchesOfBuildType: {
    readonly count: number | null | undefined;
  } | null | undefined;
};
export type BuildTypeLineBranchesCountQuery = {
  response: BuildTypeLineBranchesCountQuery$data;
  variables: BuildTypeLineBranchesCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "btLocator"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locator"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "btLocator",
        "variableName": "btLocator"
      },
      {
        "kind": "Variable",
        "name": "locator",
        "variableName": "locator"
      }
    ],
    "concreteType": "Branches",
    "kind": "LinkedField",
    "name": "branchesOfBuildType",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildTypeLineBranchesCountQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BuildTypeLineBranchesCountQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "41105eeb52b49c5711a4e6abeddbc7a6",
    "id": null,
    "metadata": {},
    "name": "BuildTypeLineBranchesCountQuery",
    "operationKind": "query",
    "text": "query BuildTypeLineBranchesCountQuery(\n  $locator: String\n  $btLocator: String!\n) {\n  branchesOfBuildType(locator: $locator, btLocator: $btLocator) {\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "14ae932057e174dc9fe60edeae1a731e";

export default node;
